export const upstoxConfig = {
  clientId: 'a8120d25-b349-496b-bc09-893df3548744',
  // Make sure this exactly matches what's in Upstox dashboard, including trailing slash if needed
  redirectUri: 'https://finomo-web-frontend.vercel.app/auth/callback',
  apiSecret: 'q99a7dv26e',
};
